import { Component, OnInit } from '@angular/core';

import { CmsService } from '@spartacus/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { DpNewsService } from '../service/news.service';
import { NewsItem } from '../types';

@Component({
    selector: 'dp-news-detail',
    templateUrl: './news-detail.component.html',
    styleUrls: ['./news-detail.component.scss'],
    standalone: false
})
export class DpNewsDetailComponent implements OnInit {
  news$!: Observable<NewsItem>;

  constructor(
    private readonly dpNewsDetailsService: DpNewsService,
    private readonly cmsService: CmsService,
  ) {}

  ngOnInit(): void {
    this.news$ = this.cmsService.getCurrentPage().pipe(
      map((pageId) => pageId?.label),
      switchMap((data) => this.dpNewsDetailsService.getNewsDetails(data)),
    );
  }

  getFormattedDate(date: string): string {
    return moment(date).format('YYYY-MM-DD');
  }
}
